import { forwardRef } from 'react';
import type { InputHTMLAttributes } from 'react';

export interface InputProps extends InputHTMLAttributes<HTMLInputElement> {
  /** 검증 실패 표시 */
  invalid?: boolean;
}

/** 관리자 공통 텍스트 입력 */
const Input = forwardRef<HTMLInputElement, InputProps>(function Input(
  { invalid = false, className = '', ...rest },
  ref,
) {
  const classes = ['input', invalid ? 'input--invalid' : '', className].filter(Boolean).join(' ');
  return <input ref={ref} className={classes} {...rest} />;
});

export default Input;
